import { render } from "./RecipePage.vue?vue&type=template&id=16d1229f"
import script from "./RecipePage.vue?vue&type=script&lang=js"
export * from "./RecipePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__